// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Pell v2 per a les pantalles internes de Gestió d'Empleat
   (Horari, Absències, Baixes, Control Horari, Calendari, Resum).
   No canvia la lògica: només reinterpreta Dashboard-* i alguns blocs
   propis perquè s'assemblin a dv2 mentre visquin dins .gestioempleat. */

.gestioempleat-content-flex {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.gestioempleat-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.gestioempleat-panel {
  min-width: 0;
}

.gestioempleat-panel > .Dashboard-form-section.horari-empresa {
  background: transparent;
  border: none;
  box-shadow: none;
  padding: 0;
}

/* Botons Dashboard → aspecte dv2 */
.gestioempleat .Dashboard-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 8px 14px;
  border-radius: 10px;
  border: 1px solid var(--dv2-border, #e2e8f0);
  background: var(--dv2-surface, #fff);
  color: var(--dv2-text, #0f172a);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  width: auto;
  box-shadow: var(--dv2-shadow, 0 1px 2px rgba(15, 23, 42, 0.06));
}

.gestioempleat .Dashboard-btn:hover {
  background: var(--dv2-surface-muted, #f8fafc);
}

.gestioempleat .Dashboard-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}

.gestioempleat .Dashboard-btn-acceptar {
  background: var(--dv2-primary, #2563eb);
  border-color: var(--dv2-primary, #2563eb);
  color: #fff;
}

.gestioempleat .Dashboard-btn-acceptar:hover {
  background: var(--dv2-primary-hover, #1d4ed8);
  border-color: var(--dv2-primary-hover, #1d4ed8);
}

.gestioempleat .Dashboard-btn-cancelar {
  background: var(--dv2-surface, #fff);
  color: var(--dv2-text, #0f172a);
}

.gestioempleat .Dashboard-btn-icona {
  min-height: 28px;
  width: 28px;
  padding: 0;
  border-radius: 8px;
}

.gestioempleat .Dashboard-btn.horari-empresa-btn-petit,
.gestioempleat .Dashboard-btn.ch-emp-btn-petit,
.gestioempleat .Dashboard-btn.absencies-emp-btn-petit,
.gestioempleat .Dashboard-btn.baixes-emp-btn-esborrar,
.gestioempleat .absencies-emp-btn-esborrar {
  min-height: 32px;
  padding: 4px 10px;
  font-size: 13px;
}

.gestioempleat .Dashboard-button-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 10px 0;
}

/* Formularis Dashboard → card / camps v2 */
.gestioempleat .Dashboard-form,
.gestioempleat .Dashboard-form-section {
  background: var(--dv2-surface-muted, #f8fafc);
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: var(--dv2-radius, 12px);
  box-shadow: none;
  padding: 14px 16px;
}

.gestioempleat .Dashboard-form-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 16px;
  margin-bottom: 10px;
}

.gestioempleat .Dashboard-form-row label,
.gestioempleat .checkbox-label {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  color: var(--dv2-text-muted, #64748b);
}

.gestioempleat .checkbox-label {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.gestioempleat input[type="text"],
.gestioempleat input[type="number"],
.gestioempleat input[type="date"],
.gestioempleat input[type="time"],
.gestioempleat input[type="datetime-local"],
.gestioempleat input[type="email"],
.gestioempleat select,
.gestioempleat textarea {
  min-height: 38px;
  padding: 8px 10px;
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: 10px;
  background: var(--dv2-surface, #fff);
  color: var(--dv2-text, #0f172a);
  font-size: 14px;
}

.gestioempleat textarea {
  min-height: 72px;
  resize: vertical;
}

.gestioempleat input:focus,
.gestioempleat select:focus,
.gestioempleat textarea:focus {
  outline: none;
  box-shadow: var(--dv2-focus, 0 0 0 3px rgba(37, 99, 235, 0.28));
}

/* Taules Dashboard → aspecte dv2 */
.gestioempleat .Dashboard-table-container {
  overflow: auto;
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: var(--dv2-radius, 12px);
  background: var(--dv2-surface, #fff);
}

.gestioempleat table.Dashboard-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.gestioempleat table.Dashboard-table th {
  text-align: left;
  font-weight: 700;
  color: var(--dv2-text-muted, #64748b);
  background: var(--dv2-surface-muted, #f8fafc);
  border-bottom: 1px solid var(--dv2-border, #e2e8f0);
  padding: 10px 12px;
}

.gestioempleat table.Dashboard-table td {
  padding: 10px 12px;
  border-bottom: 1px solid var(--dv2-border, #e2e8f0);
  color: var(--dv2-text, #0f172a);
}

.gestioempleat table.Dashboard-table tbody tr:nth-child(odd) td {
  background: #fff;
}

.gestioempleat table.Dashboard-table tbody tr:nth-child(even) td {
  background: var(--dv2-surface-muted, #f8fafc);
}

.gestioempleat table.Dashboard-table tbody tr:hover td {
  background: var(--dv2-primary-soft, #eff6ff);
}

/* Filtres / targetes internes */
.gestioempleat .baixes-emp-filtres,
.gestioempleat .absencies-emp-filtres,
.gestioempleat .chg-filtres,
.gestioempleat .ch-emp-nav,
.gestioempleat .resum-emp-nav,
.gestioempleat .absencies-emp-nav,
.gestioempleat .calendari-emp-nav,
.gestioempleat .absencies-emp-vista-selector,
.gestioempleat .calendari-emp-vista-selector {
  background: var(--dv2-surface-muted, #f8fafc);
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: var(--dv2-radius-sm, 8px);
  padding: 10px 12px;
}

.gestioempleat .resum-emp-targeta,
.gestioempleat .baixes-emp-actual,
.gestioempleat .horari-empresa-periode {
  background: var(--dv2-surface, #fff);
  border: 1px solid var(--dv2-border, #e2e8f0);
  border-radius: var(--dv2-radius, 12px);
  box-shadow: var(--dv2-shadow, 0 1px 2px rgba(15, 23, 42, 0.06));
}

.gestioempleat .horari-empresa-error,
.gestioempleat .absencies-emp-error,
.gestioempleat .baixes-emp-error,
.gestioempleat .resum-emp-error {
  color: var(--dv2-danger, #dc2626);
}

.gestioempleat .baixes-emp-btn-esborrar,
.gestioempleat .absencies-emp-btn-esborrar,
.gestioempleat .ch-emp-btn-esborrar {
  color: var(--dv2-danger, #dc2626);
  border-color: #fecaca;
  background: var(--dv2-danger-soft, #fef2f2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/gestioempleat.css"],"names":[],"mappings":"AAAA;;;wEAGwE;;AAExE;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA,mCAAmC;AACnC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,+DAA+D;AACjE;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;;EAEE,6CAA6C;EAC7C,4CAA4C;EAC5C,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;;;;;;;EAQE,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;EAC5C,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,+DAA+D;AACjE;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,4CAA4C;EAC5C,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,6CAA6C;EAC7C,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,gCAAgC;AAChC;;;;;;;;;EASE,6CAA6C;EAC7C,4CAA4C;EAC5C,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;;;EAGE,oCAAoC;EACpC,4CAA4C;EAC5C,sCAAsC;EACtC,+DAA+D;AACjE;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;;;EAGE,iCAAiC;EACjC,qBAAqB;EACrB,2CAA2C;AAC7C","sourcesContent":["/* Pell v2 per a les pantalles internes de Gestió d'Empleat\n   (Horari, Absències, Baixes, Control Horari, Calendari, Resum).\n   No canvia la lògica: només reinterpreta Dashboard-* i alguns blocs\n   propis perquè s'assemblin a dv2 mentre visquin dins .gestioempleat. */\n\n.gestioempleat-content-flex {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.gestioempleat-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.gestioempleat-panel {\n  min-width: 0;\n}\n\n.gestioempleat-panel > .Dashboard-form-section.horari-empresa {\n  background: transparent;\n  border: none;\n  box-shadow: none;\n  padding: 0;\n}\n\n/* Botons Dashboard → aspecte dv2 */\n.gestioempleat .Dashboard-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 38px;\n  padding: 8px 14px;\n  border-radius: 10px;\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  background: var(--dv2-surface, #fff);\n  color: var(--dv2-text, #0f172a);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  width: auto;\n  box-shadow: var(--dv2-shadow, 0 1px 2px rgba(15, 23, 42, 0.06));\n}\n\n.gestioempleat .Dashboard-btn:hover {\n  background: var(--dv2-surface-muted, #f8fafc);\n}\n\n.gestioempleat .Dashboard-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.gestioempleat .Dashboard-btn-acceptar {\n  background: var(--dv2-primary, #2563eb);\n  border-color: var(--dv2-primary, #2563eb);\n  color: #fff;\n}\n\n.gestioempleat .Dashboard-btn-acceptar:hover {\n  background: var(--dv2-primary-hover, #1d4ed8);\n  border-color: var(--dv2-primary-hover, #1d4ed8);\n}\n\n.gestioempleat .Dashboard-btn-cancelar {\n  background: var(--dv2-surface, #fff);\n  color: var(--dv2-text, #0f172a);\n}\n\n.gestioempleat .Dashboard-btn-icona {\n  min-height: 28px;\n  width: 28px;\n  padding: 0;\n  border-radius: 8px;\n}\n\n.gestioempleat .Dashboard-btn.horari-empresa-btn-petit,\n.gestioempleat .Dashboard-btn.ch-emp-btn-petit,\n.gestioempleat .Dashboard-btn.absencies-emp-btn-petit,\n.gestioempleat .Dashboard-btn.baixes-emp-btn-esborrar,\n.gestioempleat .absencies-emp-btn-esborrar {\n  min-height: 32px;\n  padding: 4px 10px;\n  font-size: 13px;\n}\n\n.gestioempleat .Dashboard-button-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0;\n}\n\n/* Formularis Dashboard → card / camps v2 */\n.gestioempleat .Dashboard-form,\n.gestioempleat .Dashboard-form-section {\n  background: var(--dv2-surface-muted, #f8fafc);\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: var(--dv2-radius, 12px);\n  box-shadow: none;\n  padding: 14px 16px;\n}\n\n.gestioempleat .Dashboard-form-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 12px 16px;\n  margin-bottom: 10px;\n}\n\n.gestioempleat .Dashboard-form-row label,\n.gestioempleat .checkbox-label {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--dv2-text-muted, #64748b);\n}\n\n.gestioempleat .checkbox-label {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.gestioempleat input[type=\"text\"],\n.gestioempleat input[type=\"number\"],\n.gestioempleat input[type=\"date\"],\n.gestioempleat input[type=\"time\"],\n.gestioempleat input[type=\"datetime-local\"],\n.gestioempleat input[type=\"email\"],\n.gestioempleat select,\n.gestioempleat textarea {\n  min-height: 38px;\n  padding: 8px 10px;\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: 10px;\n  background: var(--dv2-surface, #fff);\n  color: var(--dv2-text, #0f172a);\n  font-size: 14px;\n}\n\n.gestioempleat textarea {\n  min-height: 72px;\n  resize: vertical;\n}\n\n.gestioempleat input:focus,\n.gestioempleat select:focus,\n.gestioempleat textarea:focus {\n  outline: none;\n  box-shadow: var(--dv2-focus, 0 0 0 3px rgba(37, 99, 235, 0.28));\n}\n\n/* Taules Dashboard → aspecte dv2 */\n.gestioempleat .Dashboard-table-container {\n  overflow: auto;\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: var(--dv2-radius, 12px);\n  background: var(--dv2-surface, #fff);\n}\n\n.gestioempleat table.Dashboard-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.gestioempleat table.Dashboard-table th {\n  text-align: left;\n  font-weight: 700;\n  color: var(--dv2-text-muted, #64748b);\n  background: var(--dv2-surface-muted, #f8fafc);\n  border-bottom: 1px solid var(--dv2-border, #e2e8f0);\n  padding: 10px 12px;\n}\n\n.gestioempleat table.Dashboard-table td {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--dv2-border, #e2e8f0);\n  color: var(--dv2-text, #0f172a);\n}\n\n.gestioempleat table.Dashboard-table tbody tr:nth-child(odd) td {\n  background: #fff;\n}\n\n.gestioempleat table.Dashboard-table tbody tr:nth-child(even) td {\n  background: var(--dv2-surface-muted, #f8fafc);\n}\n\n.gestioempleat table.Dashboard-table tbody tr:hover td {\n  background: var(--dv2-primary-soft, #eff6ff);\n}\n\n/* Filtres / targetes internes */\n.gestioempleat .baixes-emp-filtres,\n.gestioempleat .absencies-emp-filtres,\n.gestioempleat .chg-filtres,\n.gestioempleat .ch-emp-nav,\n.gestioempleat .resum-emp-nav,\n.gestioempleat .absencies-emp-nav,\n.gestioempleat .calendari-emp-nav,\n.gestioempleat .absencies-emp-vista-selector,\n.gestioempleat .calendari-emp-vista-selector {\n  background: var(--dv2-surface-muted, #f8fafc);\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: var(--dv2-radius-sm, 8px);\n  padding: 10px 12px;\n}\n\n.gestioempleat .resum-emp-targeta,\n.gestioempleat .baixes-emp-actual,\n.gestioempleat .horari-empresa-periode {\n  background: var(--dv2-surface, #fff);\n  border: 1px solid var(--dv2-border, #e2e8f0);\n  border-radius: var(--dv2-radius, 12px);\n  box-shadow: var(--dv2-shadow, 0 1px 2px rgba(15, 23, 42, 0.06));\n}\n\n.gestioempleat .horari-empresa-error,\n.gestioempleat .absencies-emp-error,\n.gestioempleat .baixes-emp-error,\n.gestioempleat .resum-emp-error {\n  color: var(--dv2-danger, #dc2626);\n}\n\n.gestioempleat .baixes-emp-btn-esborrar,\n.gestioempleat .absencies-emp-btn-esborrar,\n.gestioempleat .ch-emp-btn-esborrar {\n  color: var(--dv2-danger, #dc2626);\n  border-color: #fecaca;\n  background: var(--dv2-danger-soft, #fef2f2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
